import { Box, Tab, Tabs } from '@mui/material';

const CustomTab = ({ onChange, value, tabList }: any) => {
  return (
    <Box sx={{ maxWidth: '100%', overflowX: 'auto' }}>
      <Tabs
        value={value}
        onChange={onChange}
        variant='scrollable'
        scrollButtons='auto'
        allowScrollButtonsMobile
      >
        {tabList?.map((item: any) => (
          <Tab label={item} sx={{ textTransform: 'capitalize' }} />
        ))}
      </Tabs>
    </Box>
  );
};

export default CustomTab;
